import * as React from "react";
import styles from "./CompositionList.module.scss";
import { useMst } from "../../../store/root";
import Search from "../SearchComponent/Search";
import ListView from "../ListView/ListView";
import { observer } from "mobx-react-lite";
import CompositionItem from "../CompositionItem/CompositionItem";
import { List } from "antd";
export type FilteredComposition = {
  name: string;
  id: number;
};

export const CompositionList = observer(() => {
  const {
    compositionStore: { sortedFilteredCompositions, queuedCompositions },
    renderStore: { isRendering },
    uiStore: { filterComposition },
  } = useMst();
  const [searchInput, setSearchInput] = React.useState("");
  const [compositions, setCompositions] = React.useState<FilteredComposition[]>(
    sortedFilteredCompositions
  );
  // This UseEffect will trigger the updated sorted list
  React.useEffect(() => {
    setCompositions(sortedFilteredCompositions);
  }, [
    queuedCompositions.join(""),
    filterComposition,
    sortedFilteredCompositions,
    isRendering,
  ]);

  React.useEffect(() => {
    isRendering && setSearchInput(""); // Clear search input when rendering
  }, [isRendering]);

  return (
    <div className={styles.CompositionList}>
      <Search
        disabled={isRendering}
        placeholder="Search Compositions"
        value={searchInput}
        onChange={setSearchInput}
      />
      <div className={styles.List}>
        <ListView
          dataSource={compositions}
          searchInput={searchInput}
          renderItem={(item: FilteredComposition) => (
            <List.Item key={item.id} className={styles.ListItem}>
              <CompositionItem item={item} />
            </List.Item>
          )}
          style={{ height: "calc(100vh - 21rem)" }}
        />
      </div>
    </div>
  );
});
